import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {
    login,
    resendConfirmationEmail
} from '../../actions/Index';
import {toastr} from 'react-redux-toastr';
import {langs} from '../../config/localization';
import {getAuthUserFullName, updateUserDetailsLocalStorage} from "../../actions/Common";
import {Loader} from "../Common/Loader";

class AfterVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleModal     : false,
            modalType       : '',
            username        : '',
            accessToken     : '',
            tokenType       : '',
            showLoader      : false,
            userFirstName : getAuthUserFullName(),
        };
    }


    /**
     * Render the login form
     * @returns {*}
     */
    render(){
        if(!this.state.showLoader) {
            return (
                <section className="success-page">
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="breadcumb">
                                {/* <a href="" className="">Dashboard </a> > <a href="" className="active">Edit Profile</a> > <a href="" className="active"></a> */}
                                <a href="/dashboard" className="first-upper breadcumb-underline">My earthDECK</a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <h2 className="page-heading">{this.state.userFirstName} earthDECK</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <p className="text-center"><img src="/assets/images/eathdeck/Success.png" /></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="success-message">
                                <p className="text-center"><a href="/dashboard"><img src="/assets/images/eathdeck/click_font.png" /></a></p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <p className="text-center m-t10 m-b40">As you watched the film and tapped on the globe, you produced <br /> your earthDECK, which maps your clicks to tags.</p>
                        </div>
                    </div>
                </section>

            );
        } else {
            return <Loader/>
        }
    }
}

export default AfterVideo;



// WEBPACK FOOTER //
// ./components/StaticPages/AfterVideo.js